import type { TrackSummary } from './localLibrary/LocalLibraryAdapter';
import type { CatalogSearchTrack } from './unifiedSearchTypes';

export function normalizeLocalSearchTrack(track: TrackSummary): CatalogSearchTrack {
  const artist = String(track.artist || track.artist_name || '');
  const album = String(track.album || track.album_title || '');
  return {
    id: track.id,
    title: track.title || 'Unknown',
    artist,
    album,
    duration: track.duration || 0,
    source: 'local',
    sourceLabel: 'Library',
    file_path: track.file_path ?? undefined,
    machine_id: track.machine_id ?? undefined,
    format: track.format ?? undefined,
  };
}
